/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import Container from "../../components/Container/Container";
import Table from "../../components/Table/Table";
import { API, STATIC, ROUTER } from "../../constants/env";
import swal from "sweetalert";

import ModalSeeMore from "./ModalSeeMore";

function ListUsers() {
  const fields = [
    { title: "Photo", field: "picture" },
    { title: "Prénom", field: "firstName" },
    { title: "Nom", field: "lastName" },
    { title: "Tél", field: "phone" },
    { title: "Adresse", field: "adress" },
    { title: "Voir Plus", field: "seeMore" },
  ];
  const [data, setData] = React.useState([]);
  const fetchData = (currentPage, count, search, setTotalPage, setTotal) => {
    fetch(
      API.teachers.list +
        `?page=${currentPage}&count=${count}&searchQuery=${search}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("token"),
        },
      }
    )
      .then((res) => res.json())
      .then((response) => {
        if (response.error) {
          return swal("Error", response.message, "error");
        }
        const result = response.data.map((elem) => ({
          _id: elem._id,
          picture: (
            <img
              src={STATIC.ROUTE(elem.profil.picture)}
              className="rounded imgWidthThumbnail"
              alt="teacher_pic"
            />
          ),
          firstName: elem.profil.firstName,
          lastName: elem.profil.lastName,
          phone: elem.profil.phone,
          adress: elem.profil.adress,
          seeMore: <ModalSeeMore id={elem._id} />,
        }));
        setData(result);
        setTotalPage(response.totalPage);
        setTotal(response.total);
      })
      .catch((e) => {
        return swal("Error", e.message, "error");
      });
  };

  return (
    <Container
      name="Liste des enseignants"
      actionRoute={ROUTER.TEACHERS.CREATE}
      actionName="Ajouter un(e) enseignant(e)"
    >
      <Table
        pageName="tch"
        name="Les Enseignants"
        fields={fields}
        data={data}
        editRoute={(id) => ROUTER.TEACHERS.EDIT(id)}
        deleteApiRoute={API.teachers.remove}
        deleteMultiple={API.teachers.deleteMultiple}
        fetchData={fetchData}
        showSearch={true}
      />
    </Container>
  );
}

export default ListUsers;
